// extracted by mini-css-extract-plugin
export default {"thisTable":"AuthoritySetting_thisTable__e2WfT"};